/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LobbyImageModel } from '../../models/lobby-image-model';

export interface LobbyLobbyImageContentLobbyIdGet$Params {
  lobbyId: string;
}

export function lobbyLobbyImageContentLobbyIdGet(http: HttpClient, rootUrl: string, params: LobbyLobbyImageContentLobbyIdGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<Array<LobbyImageModel>>> {
  const rb = new RequestBuilder(rootUrl, lobbyLobbyImageContentLobbyIdGet.PATH, 'get');
  if (params) {
    rb.path('lobbyId', params.lobbyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<Array<LobbyImageModel>>;
    })
  );
}

lobbyLobbyImageContentLobbyIdGet.PATH = '/Lobby/LobbyImageContent/{lobbyId}';
